import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import _StudentService from "../modules/StudentService";
import { routes } from '../routes/Routes';

import { Spin, Alert } from "antd";

export default function AfterPayment() {
	const [show, setShow] = useState(true);
	const [loading, setLoading] = useState(true);
	const [messageType, setMessageType] = useState("info");
	const [message, setMessage] = useState("Transaction Information");
	const [messageDescription, setMessageDescription] = useState("Please wait, Transaction is in progress.....");
	const [tabID, setTabID] = useState(-1)

	useEffect(() => {
		let interval = setInterval(() => {
			if (show) {
				try {
					let response = _StudentService.verifyPaymentStatus().then(
						function (value) {
							if (value && value.status == 200 && value.data.IsSuccess) {
								setShow(false)
								setLoading(false)
								if (value.data && value.data.Obj) {
									if (value.data.Obj.TransactionStatus === "Success") {
										setMessageType("success")
										setMessage("Payment Successful")
										setMessageDescription("Transaction Successful")
										setTimeout(function () {
											setTabID(6)
										}, 2000);
									}
									else {
										setMessageType("error")
										setMessage("Failed")
										setMessageDescription(value.data.Obj.Error_Reason)
										setTimeout(function () {
											setTabID(5)
										}, 2000);
									}
								}
							}

						},
						function (error) {
							setShow(false)
							setLoading(false)
							setMessageType("error")
							setMessage("Failed")
							setMessageDescription("Error occured while initiating payment, please try again.")
							console.error("error:--- function=> ", error);
							setTimeout(function () {
								setTabID(5)
							}, 2000);
						}
					);
				} catch (e) {
					setShow(false)
					setLoading(false)
					setMessageType("error")
					setMessage("Failed")
					setMessageDescription("Error occured while initiating payment, please try again.")
					console.error("e:--- catch=> ", e);
					setTimeout(function () {
						setTabID(5)
					}, 2000);
				}
			}
		}, 2000);
		return () => {
			clearInterval(interval);
		};
	});

	return (
		<div className="ch-container gl-bxbr analysisWrap p-4 mt-4">
			<div className="candidateform-cover pr-3 pl-3 pb-3" role="status" aria-live="polite">
				<Spin size="large" spinning={loading}>
					<Alert
						type={messageType}
						message={message}
						description={messageDescription}
						showIcon
					/>
				</Spin>
			</div>
			{
				tabID > 0 &&
				<Redirect to={{
					pathname: routes.home.basePath,
					state: { tabID: tabID }
				}} />
			}
		</div>
	)
}

